// features/reportes/api/reportes.api.js
// Capa de API para reportes de certificados dinámica conectada a ms-emisiones.

import { api } from '../../../api/client';

export const reportsApi = {
  /**
   * Lista todos los certificados emitidos (o filtrados por tipo opcional).
   * @param {string} [tipo]
   * @returns {Promise<Array>}
   */
  search: (searchData={}) => {
    //const query = tipo ? `?tipo=${encodeURIComponent(tipo)}` : '';
    return api.post(`/reports/certificates/search`, searchData);
  },

  /**
   * Obtiene la lista de tipos de certificados disponibles dinámicamente.
   * @returns {Promise<string[]>}
   */
  getTypes: () => api.get('/emisiones/certificates/types'),

  /**
   * Genera y descarga el reporte ejecutivo en PDF.
   * @param {{ page: number, size: number }} pageData
   * @returns {Promise<Blob>}
   */
  exportPdf: async (pageData) => {
    const blob = await api.postBlob('/reports/certificates/executive-report/pdf', {
      page: pageData.page,
      size: pageData.size,
    });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    const dateStr = new Date().toISOString().slice(0, 10);
    a.download = `reporte-ejecutivo-${dateStr}.pdf`;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
    return blob;
  },

  /**
   * Descarga el PDF de un certificado específico por folio y tipo opcional.
   * @param {string} folio
   * @param {string} [tipo]
   * @returns {Promise<Blob>}
   */
  downloadCertificatePdf: (folio, tipo) => {
    const query = tipo ? `?tipo=${encodeURIComponent(tipo)}` : '';
    return api.getBlob(`/emisiones/certificates/download/${folio}/pdf${query}`);
  },
};
